export default {
    nestedItem: Symbol('Nested Item'),
};
//# sourceMappingURL=itemTypes.js.map